var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailyReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.78,4.33H14a2.68,2.68,0,0,0-5,0H5.23a1.8,1.8,0,0,0-1.8,1.79V18.68a1.8,1.8,0,0,0,1.8,1.79H17.78a1.79,1.79,0,0,0,1.79-1.79V6.12A1.79,1.79,0,0,0,17.78,4.33Zm-6.28,0a.9.9,0,1,1-.89.9A.9.9,0,0,1,11.5,4.33Zm1.8,12.55H7V15.09H13.3ZM16,13.3H7V11.5h9Zm0-3.59H7V7.92h9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyReportsIcon);
export default __webpack_public_path__ + "static/media/daily_reports_icon.a326b5798cdf0091f62b852334a7aff3.svg";
export { ForwardRef as ReactComponent };